{
  "formatVersion": 1,
  "name": "blackline-overgrowth",
  "displayName": "Overgrowth",
  "description": "Overgrown stone temple ruins in a jungle clearing at golden hour: attackers start in a sunken jungle path, defenders on a raised temple terrace with a shaded undercroft behind it. A 53 m walled straight runs through a stone gate at the centre, a wide stair climbs to the elevated plateau at A, and a roofed tunnel opens onto the rim of the sunken pit courtyard at B.",
  "visual": null,
  "environment": "golden",
  "brushes": [
    {
      "kind": "box",
      "center": [
        -11,
        -1.25,
        0
      ],
      "halfExtents": [
        31,
        1.25,
        37
      ],
      "material": "sand",
      "note": "jungle floor west"
    },
    {
      "kind": "box",
      "center": [
        31,
        -1.25,
        -32.5
      ],
      "halfExtents": [
        11,
        1.25,
        4.5
      ],
      "material": "sand",
      "note": "jungle floor north-east"
    },
    {
      "kind": "box",
      "center": [
        31,
        -1.25,
        13.5
      ],
      "halfExtents": [
        11,
        1.25,
        23.5
      ],
      "material": "sand",
      "note": "jungle floor south-east"
    },
    {
      "kind": "box",
      "center": [
        40,
        -1.25,
        -19
      ],
      "halfExtents": [
        2,
        1.25,
        9
      ],
      "material": "sand",
      "note": "pit east rim"
    },
    {
      "kind": "box",
      "center": [
        29,
        -2,
        -19
      ],
      "halfExtents": [
        9,
        0.5,
        9
      ],
      "material": "tile",
      "note": "B pit floor"
    },
    {
      "kind": "box",
      "center": [
        0,
        3.5,
        -36.75
      ],
      "halfExtents": [
        42,
        3.5,
        0.25
      ],
      "material": "brick",
      "note": "perimeter north wall"
    },
    {
      "kind": "box",
      "center": [
        0,
        3.5,
        36.75
      ],
      "halfExtents": [
        42,
        3.5,
        0.25
      ],
      "material": "brick",
      "note": "perimeter south wall"
    },
    {
      "kind": "box",
      "center": [
        41.75,
        3.5,
        0
      ],
      "halfExtents": [
        0.25,
        3.5,
        36.5
      ],
      "material": "brick",
      "note": "perimeter east wall"
    },
    {
      "kind": "box",
      "center": [
        -41.75,
        3.5,
        0
      ],
      "halfExtents": [
        0.25,
        3.5,
        36.5
      ],
      "material": "brick",
      "note": "perimeter west wall"
    },
    {
      "kind": "box",
      "center": [
        0,
        -0.14,
        31.75
      ],
      "halfExtents": [
        19,
        0.15,
        4.75
      ],
      "material": "gravel",
      "note": "T0 path"
    },
    {
      "kind": "box",
      "center": [
        0,
        2,
        26.75
      ],
      "halfExtents": [
        19,
        2,
        0.25
      ],
      "material": "brick",
      "note": "T0 path north wall"
    },
    {
      "kind": "box",
      "center": [
        -8.5,
        0.505,
        30.75
      ],
      "halfExtents": [
        4.5,
        0.495,
        0.25
      ],
      "material": "brick",
      "note": "T0 low stone wall"
    },
    {
      "kind": "box",
      "center": [
        8.5,
        0.505,
        30.75
      ],
      "halfExtents": [
        4.5,
        0.495,
        0.25
      ],
      "material": "brick",
      "note": "T0 low stone wall"
    },
    {
      "kind": "box",
      "center": [
        -24,
        0.45,
        34
      ],
      "halfExtents": [
        0.7,
        0.45,
        0.7
      ],
      "material": "sand",
      "hidden": true,
      "note": "rock collision"
    },
    {
      "kind": "box",
      "center": [
        24,
        0.45,
        34
      ],
      "halfExtents": [
        0.7,
        0.45,
        0.7
      ],
      "material": "sand",
      "hidden": true,
      "note": "rock collision"
    },
    {
      "kind": "box",
      "center": [
        -12,
        0.7,
        23
      ],
      "halfExtents": [
        1.5,
        0.7,
        1
      ],
      "material": "brick",
      "note": "stone block"
    },
    {
      "kind": "box",
      "center": [
        12,
        0.7,
        23
      ],
      "halfExtents": [
        1.5,
        0.7,
        1
      ],
      "material": "brick",
      "note": "stone block"
    },
    {
      "kind": "box",
      "center": [
        0,
        2.3,
        -31.75
      ],
      "halfExtents": [
        18,
        0.2,
        4.75
      ],
      "material": "tile",
      "note": "terrace deck"
    },
    {
      "kind": "box",
      "center": [
        -15,
        1.05,
        -34.5
      ],
      "halfExtents": [
        0.35,
        1.05,
        0.35
      ],
      "material": "brick",
      "note": "terrace column"
    },
    {
      "kind": "box",
      "center": [
        -7.5,
        1.05,
        -34.5
      ],
      "halfExtents": [
        0.35,
        1.05,
        0.35
      ],
      "material": "brick",
      "note": "terrace column"
    },
    {
      "kind": "box",
      "center": [
        0,
        1.05,
        -34.5
      ],
      "halfExtents": [
        0.35,
        1.05,
        0.35
      ],
      "material": "brick",
      "note": "terrace column"
    },
    {
      "kind": "box",
      "center": [
        7.5,
        1.05,
        -34.5
      ],
      "halfExtents": [
        0.35,
        1.05,
        0.35
      ],
      "material": "brick",
      "note": "terrace column"
    },
    {
      "kind": "box",
      "center": [
        15,
        1.05,
        -34.5
      ],
      "halfExtents": [
        0.35,
        1.05,
        0.35
      ],
      "material": "brick",
      "note": "terrace column"
    },
    {
      "kind": "box",
      "center": [
        -15,
        1.05,
        -31.5
      ],
      "halfExtents": [
        0.35,
        1.05,
        0.35
      ],
      "material": "brick",
      "note": "terrace column"
    },
    {
      "kind": "box",
      "center": [
        -7.5,
        1.05,
        -31.5
      ],
      "halfExtents": [
        0.35,
        1.05,
        0.35
      ],
      "material": "brick",
      "note": "terrace column"
    },
    {
      "kind": "box",
      "center": [
        0,
        1.05,
        -31.5
      ],
      "halfExtents": [
        0.35,
        1.05,
        0.35
      ],
      "material": "brick",
      "note": "terrace column"
    },
    {
      "kind": "box",
      "center": [
        7.5,
        1.05,
        -31.5
      ],
      "halfExtents": [
        0.35,
        1.05,
        0.35
      ],
      "material": "brick",
      "note": "terrace column"
    },
    {
      "kind": "box",
      "center": [
        15,
        1.05,
        -31.5
      ],
      "halfExtents": [
        0.35,
        1.05,
        0.35
      ],
      "material": "brick",
      "note": "terrace column"
    },
    {
      "kind": "box",
      "center": [
        0,
        1.8,
        -26.75
      ],
      "halfExtents": [
        19,
        1.8,
        0.25
      ],
      "material": "brick",
      "note": "terrace parapet wall"
    },
    {
      "kind": "box",
      "center": [
        -8,
        3,
        -29.5
      ],
      "halfExtents": [
        1.2,
        0.5,
        0.8
      ],
      "material": "brick",
      "note": "terrace block"
    },
    {
      "kind": "box",
      "center": [
        8,
        3,
        -29.5
      ],
      "halfExtents": [
        1.2,
        0.5,
        0.8
      ],
      "material": "brick",
      "note": "terrace block"
    },
    {
      "kind": "box",
      "center": [
        21.723,
        0.075,
        -32
      ],
      "halfExtents": [
        0.113,
        0.075,
        1.5
      ],
      "material": "tile",
      "note": "terrace east stair step 1"
    },
    {
      "kind": "box",
      "center": [
        21.498,
        0.15,
        -32
      ],
      "halfExtents": [
        0.113,
        0.15,
        1.5
      ],
      "material": "tile",
      "note": "terrace east stair step 2"
    },
    {
      "kind": "box",
      "center": [
        21.273,
        0.225,
        -32
      ],
      "halfExtents": [
        0.113,
        0.225,
        1.5
      ],
      "material": "tile",
      "note": "terrace east stair step 3"
    },
    {
      "kind": "box",
      "center": [
        21.048,
        0.3,
        -32
      ],
      "halfExtents": [
        0.113,
        0.3,
        1.5
      ],
      "material": "tile",
      "note": "terrace east stair step 4"
    },
    {
      "kind": "box",
      "center": [
        20.823,
        0.375,
        -32
      ],
      "halfExtents": [
        0.113,
        0.375,
        1.5
      ],
      "material": "tile",
      "note": "terrace east stair step 5"
    },
    {
      "kind": "box",
      "center": [
        20.598,
        0.45,
        -32
      ],
      "halfExtents": [
        0.113,
        0.45,
        1.5
      ],
      "material": "tile",
      "note": "terrace east stair step 6"
    },
    {
      "kind": "box",
      "center": [
        20.373,
        0.525,
        -32
      ],
      "halfExtents": [
        0.113,
        0.525,
        1.5
      ],
      "material": "tile",
      "note": "terrace east stair step 7"
    },
    {
      "kind": "box",
      "center": [
        20.148,
        0.6,
        -32
      ],
      "halfExtents": [
        0.113,
        0.6,
        1.5
      ],
      "material": "tile",
      "note": "terrace east stair step 8"
    },
    {
      "kind": "box",
      "center": [
        19.923,
        0.675,
        -32
      ],
      "halfExtents": [
        0.113,
        0.675,
        1.5
      ],
      "material": "tile",
      "note": "terrace east stair step 9"
    },
    {
      "kind": "box",
      "center": [
        19.698,
        0.75,
        -32
      ],
      "halfExtents": [
        0.113,
        0.75,
        1.5
      ],
      "material": "tile",
      "note": "terrace east stair step 10"
    },
    {
      "kind": "box",
      "center": [
        19.473,
        0.825,
        -32
      ],
      "halfExtents": [
        0.113,
        0.825,
        1.5
      ],
      "material": "tile",
      "note": "terrace east stair step 11"
    },
    {
      "kind": "box",
      "center": [
        19.248,
        0.9,
        -32
      ],
      "halfExtents": [
        0.113,
        0.9,
        1.5
      ],
      "material": "tile",
      "note": "terrace east stair step 12"
    },
    {
      "kind": "box",
      "center": [
        19.023,
        0.975,
        -32
      ],
      "halfExtents": [
        0.113,
        0.975,
        1.5
      ],
      "material": "tile",
      "note": "terrace east stair step 13"
    },
    {
      "kind": "box",
      "center": [
        18.798,
        1.05,
        -32
      ],
      "halfExtents": [
        0.113,
        1.05,
        1.5
      ],
      "material": "tile",
      "note": "terrace east stair step 14"
    },
    {
      "kind": "box",
      "center": [
        18.573,
        1.125,
        -32
      ],
      "halfExtents": [
        0.113,
        1.125,
        1.5
      ],
      "material": "tile",
      "note": "terrace east stair step 15"
    },
    {
      "kind": "box",
      "center": [
        18.348,
        1.2,
        -32
      ],
      "halfExtents": [
        0.113,
        1.2,
        1.5
      ],
      "material": "tile",
      "note": "terrace east stair step 16"
    },
    {
      "kind": "box",
      "center": [
        18.123,
        1.25,
        -32
      ],
      "halfExtents": [
        0.113,
        1.25,
        1.5
      ],
      "material": "tile",
      "note": "terrace east stair step 17"
    },
    {
      "kind": "box",
      "center": [
        -21.722,
        0.075,
        -32
      ],
      "halfExtents": [
        0.113,
        0.075,
        1.5
      ],
      "material": "tile",
      "note": "terrace west stair step 1"
    },
    {
      "kind": "box",
      "center": [
        -21.498,
        0.15,
        -32
      ],
      "halfExtents": [
        0.113,
        0.15,
        1.5
      ],
      "material": "tile",
      "note": "terrace west stair step 2"
    },
    {
      "kind": "box",
      "center": [
        -21.272,
        0.225,
        -32
      ],
      "halfExtents": [
        0.113,
        0.225,
        1.5
      ],
      "material": "tile",
      "note": "terrace west stair step 3"
    },
    {
      "kind": "box",
      "center": [
        -21.047,
        0.3,
        -32
      ],
      "halfExtents": [
        0.113,
        0.3,
        1.5
      ],
      "material": "tile",
      "note": "terrace west stair step 4"
    },
    {
      "kind": "box",
      "center": [
        -20.822,
        0.375,
        -32
      ],
      "halfExtents": [
        0.113,
        0.375,
        1.5
      ],
      "material": "tile",
      "note": "terrace west stair step 5"
    },
    {
      "kind": "box",
      "center": [
        -20.597,
        0.45,
        -32
      ],
      "halfExtents": [
        0.113,
        0.45,
        1.5
      ],
      "material": "tile",
      "note": "terrace west stair step 6"
    },
    {
      "kind": "box",
      "center": [
        -20.373,
        0.525,
        -32
      ],
      "halfExtents": [
        0.113,
        0.525,
        1.5
      ],
      "material": "tile",
      "note": "terrace west stair step 7"
    },
    {
      "kind": "box",
      "center": [
        -20.147,
        0.6,
        -32
      ],
      "halfExtents": [
        0.113,
        0.6,
        1.5
      ],
      "material": "tile",
      "note": "terrace west stair step 8"
    },
    {
      "kind": "box",
      "center": [
        -19.922,
        0.675,
        -32
      ],
      "halfExtents": [
        0.113,
        0.675,
        1.5
      ],
      "material": "tile",
      "note": "terrace west stair step 9"
    },
    {
      "kind": "box",
      "center": [
        -19.697,
        0.75,
        -32
      ],
      "halfExtents": [
        0.113,
        0.75,
        1.5
      ],
      "material": "tile",
      "note": "terrace west stair step 10"
    },
    {
      "kind": "box",
      "center": [
        -19.472,
        0.825,
        -32
      ],
      "halfExtents": [
        0.113,
        0.825,
        1.5
      ],
      "material": "tile",
      "note": "terrace west stair step 11"
    },
    {
      "kind": "box",
      "center": [
        -19.248,
        0.9,
        -32
      ],
      "halfExtents": [
        0.113,
        0.9,
        1.5
      ],
      "material": "tile",
      "note": "terrace west stair step 12"
    },
    {
      "kind": "box",
      "center": [
        -19.022,
        0.975,
        -32
      ],
      "halfExtents": [
        0.113,
        0.975,
        1.5
      ],
      "material": "tile",
      "note": "terrace west stair step 13"
    },
    {
      "kind": "box",
      "center": [
        -18.797,
        1.05,
        -32
      ],
      "halfExtents": [
        0.113,
        1.05,
        1.5
      ],
      "material": "tile",
      "note": "terrace west stair step 14"
    },
    {
      "kind": "box",
      "center": [
        -18.572,
        1.125,
        -32
      ],
      "halfExtents": [
        0.113,
        1.125,
        1.5
      ],
      "material": "tile",
      "note": "terrace west stair step 15"
    },
    {
      "kind": "box",
      "center": [
        -18.347,
        1.2,
        -32
      ],
      "halfExtents": [
        0.113,
        1.2,
        1.5
      ],
      "material": "tile",
      "note": "terrace west stair step 16"
    },
    {
      "kind": "box",
      "center": [
        -18.123,
        1.25,
        -32
      ],
      "halfExtents": [
        0.113,
        1.25,
        1.5
      ],
      "material": "tile",
      "note": "terrace west stair step 17"
    },
    {
      "kind": "box",
      "center": [
        -11.25,
        2,
        -31.5
      ],
      "halfExtents": [
        0.12,
        0.05,
        0.12
      ],
      "material": "metal",
      "emissive": "#ffd8a0",
      "emissiveIntensity": 3,
      "note": "undercroft lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -3.75,
        2,
        -31.5
      ],
      "halfExtents": [
        0.12,
        0.05,
        0.12
      ],
      "material": "metal",
      "emissive": "#ffd8a0",
      "emissiveIntensity": 3,
      "note": "undercroft lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        3.75,
        2,
        -31.5
      ],
      "halfExtents": [
        0.12,
        0.05,
        0.12
      ],
      "material": "metal",
      "emissive": "#ffd8a0",
      "emissiveIntensity": 3,
      "note": "undercroft lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        11.25,
        2,
        -31.5
      ],
      "halfExtents": [
        0.12,
        0.05,
        0.12
      ],
      "material": "metal",
      "emissive": "#ffd8a0",
      "emissiveIntensity": 3,
      "note": "undercroft lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        0,
        -0.14,
        -3.25
      ],
      "halfExtents": [
        7,
        0.15,
        23.25
      ],
      "material": "tile",
      "note": "mid paving"
    },
    {
      "kind": "box",
      "center": [
        -7.25,
        2.5,
        -23.25
      ],
      "halfExtents": [
        0.25,
        2.5,
        3.25
      ],
      "material": "brick",
      "note": "mid west wall"
    },
    {
      "kind": "box",
      "center": [
        -7.25,
        3.8,
        -18.5
      ],
      "halfExtents": [
        0.25,
        1.2,
        1.5
      ],
      "material": "brick",
      "note": "mid west wall lintel"
    },
    {
      "kind": "box",
      "center": [
        -7.25,
        2.45,
        -18.5
      ],
      "halfExtents": [
        0.25,
        0.05,
        0.15
      ],
      "material": "metal",
      "emissive": "#ffcf90",
      "emissiveIntensity": 3,
      "note": "mid doorway lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -7.25,
        2.5,
        -3.5
      ],
      "halfExtents": [
        0.25,
        2.5,
        13.5
      ],
      "material": "brick",
      "note": "mid west wall"
    },
    {
      "kind": "box",
      "center": [
        -7.25,
        3.8,
        11.5
      ],
      "halfExtents": [
        0.25,
        1.2,
        1.5
      ],
      "material": "brick",
      "note": "mid west wall lintel"
    },
    {
      "kind": "box",
      "center": [
        -7.25,
        2.45,
        11.5
      ],
      "halfExtents": [
        0.25,
        0.05,
        0.15
      ],
      "material": "metal",
      "emissive": "#ffcf90",
      "emissiveIntensity": 3,
      "note": "mid doorway lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -7.25,
        2.5,
        16.5
      ],
      "halfExtents": [
        0.25,
        2.5,
        3.5
      ],
      "material": "brick",
      "note": "mid west wall"
    },
    {
      "kind": "box",
      "center": [
        7.25,
        2.5,
        -23.25
      ],
      "halfExtents": [
        0.25,
        2.5,
        3.25
      ],
      "material": "brick",
      "note": "mid east wall"
    },
    {
      "kind": "box",
      "center": [
        7.25,
        3.8,
        -18.5
      ],
      "halfExtents": [
        0.25,
        1.2,
        1.5
      ],
      "material": "brick",
      "note": "mid east wall lintel"
    },
    {
      "kind": "box",
      "center": [
        7.25,
        2.45,
        -18.5
      ],
      "halfExtents": [
        0.25,
        0.05,
        0.15
      ],
      "material": "metal",
      "emissive": "#ffcf90",
      "emissiveIntensity": 3,
      "note": "mid doorway lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        7.25,
        2.5,
        -3.5
      ],
      "halfExtents": [
        0.25,
        2.5,
        13.5
      ],
      "material": "brick",
      "note": "mid east wall"
    },
    {
      "kind": "box",
      "center": [
        7.25,
        3.8,
        11.5
      ],
      "halfExtents": [
        0.25,
        1.2,
        1.5
      ],
      "material": "brick",
      "note": "mid east wall lintel"
    },
    {
      "kind": "box",
      "center": [
        7.25,
        2.45,
        11.5
      ],
      "halfExtents": [
        0.25,
        0.05,
        0.15
      ],
      "material": "metal",
      "emissive": "#ffcf90",
      "emissiveIntensity": 3,
      "note": "mid doorway lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        7.25,
        2.5,
        16.5
      ],
      "halfExtents": [
        0.25,
        2.5,
        3.5
      ],
      "material": "brick",
      "note": "mid east wall"
    },
    {
      "kind": "box",
      "center": [
        -5,
        1.6,
        0
      ],
      "halfExtents": [
        2,
        1.6,
        1
      ],
      "material": "brick",
      "note": "gate pier"
    },
    {
      "kind": "box",
      "center": [
        5,
        1.6,
        0
      ],
      "halfExtents": [
        2,
        1.6,
        1
      ],
      "material": "brick",
      "note": "gate pier"
    },
    {
      "kind": "box",
      "center": [
        0,
        3.9,
        0
      ],
      "halfExtents": [
        7,
        0.7,
        1
      ],
      "material": "brick",
      "note": "gate lintel"
    },
    {
      "kind": "box",
      "center": [
        -2.8,
        3,
        0
      ],
      "halfExtents": [
        0.15,
        0.05,
        0.15
      ],
      "material": "metal",
      "emissive": "#ffcf90",
      "emissiveIntensity": 3,
      "note": "gate lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        2.8,
        3,
        0
      ],
      "halfExtents": [
        0.15,
        0.05,
        0.15
      ],
      "material": "metal",
      "emissive": "#ffcf90",
      "emissiveIntensity": 3,
      "note": "gate lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -4.5,
        0.6,
        -12
      ],
      "halfExtents": [
        1.2,
        0.6,
        0.8
      ],
      "material": "brick",
      "note": "stone block"
    },
    {
      "kind": "box",
      "center": [
        4.5,
        0.7,
        -8
      ],
      "halfExtents": [
        1.2,
        0.7,
        0.8
      ],
      "material": "brick",
      "note": "stone block"
    },
    {
      "kind": "box",
      "center": [
        -4.5,
        0.7,
        7
      ],
      "halfExtents": [
        1.2,
        0.7,
        0.8
      ],
      "material": "brick",
      "note": "stone block"
    },
    {
      "kind": "box",
      "center": [
        4.5,
        0.6,
        15
      ],
      "halfExtents": [
        1.2,
        0.6,
        0.8
      ],
      "material": "brick",
      "note": "stone block"
    },
    {
      "kind": "box",
      "center": [
        -26.75,
        1.5,
        -15
      ],
      "halfExtents": [
        14.75,
        1.5,
        9
      ],
      "material": "tile",
      "note": "A plateau"
    },
    {
      "kind": "box",
      "center": [
        -24,
        0.075,
        -1.602
      ],
      "halfExtents": [
        2,
        0.075,
        0.113
      ],
      "material": "tile",
      "note": "A south stair step 1"
    },
    {
      "kind": "box",
      "center": [
        -24,
        0.15,
        -1.828
      ],
      "halfExtents": [
        2,
        0.15,
        0.113
      ],
      "material": "tile",
      "note": "A south stair step 2"
    },
    {
      "kind": "box",
      "center": [
        -24,
        0.225,
        -2.052
      ],
      "halfExtents": [
        2,
        0.225,
        0.113
      ],
      "material": "tile",
      "note": "A south stair step 3"
    },
    {
      "kind": "box",
      "center": [
        -24,
        0.3,
        -2.277
      ],
      "halfExtents": [
        2,
        0.3,
        0.113
      ],
      "material": "tile",
      "note": "A south stair step 4"
    },
    {
      "kind": "box",
      "center": [
        -24,
        0.375,
        -2.502
      ],
      "halfExtents": [
        2,
        0.375,
        0.113
      ],
      "material": "tile",
      "note": "A south stair step 5"
    },
    {
      "kind": "box",
      "center": [
        -24,
        0.45,
        -2.727
      ],
      "halfExtents": [
        2,
        0.45,
        0.113
      ],
      "material": "tile",
      "note": "A south stair step 6"
    },
    {
      "kind": "box",
      "center": [
        -24,
        0.525,
        -2.952
      ],
      "halfExtents": [
        2,
        0.525,
        0.113
      ],
      "material": "tile",
      "note": "A south stair step 7"
    },
    {
      "kind": "box",
      "center": [
        -24,
        0.6,
        -3.177
      ],
      "halfExtents": [
        2,
        0.6,
        0.113
      ],
      "material": "tile",
      "note": "A south stair step 8"
    },
    {
      "kind": "box",
      "center": [
        -24,
        0.675,
        -3.402
      ],
      "halfExtents": [
        2,
        0.675,
        0.113
      ],
      "material": "tile",
      "note": "A south stair step 9"
    },
    {
      "kind": "box",
      "center": [
        -24,
        0.75,
        -3.628
      ],
      "halfExtents": [
        2,
        0.75,
        0.113
      ],
      "material": "tile",
      "note": "A south stair step 10"
    },
    {
      "kind": "box",
      "center": [
        -24,
        0.825,
        -3.852
      ],
      "halfExtents": [
        2,
        0.825,
        0.113
      ],
      "material": "tile",
      "note": "A south stair step 11"
    },
    {
      "kind": "box",
      "center": [
        -24,
        0.9,
        -4.077
      ],
      "halfExtents": [
        2,
        0.9,
        0.113
      ],
      "material": "tile",
      "note": "A south stair step 12"
    },
    {
      "kind": "box",
      "center": [
        -24,
        0.975,
        -4.302
      ],
      "halfExtents": [
        2,
        0.975,
        0.113
      ],
      "material": "tile",
      "note": "A south stair step 13"
    },
    {
      "kind": "box",
      "center": [
        -24,
        1.05,
        -4.527
      ],
      "halfExtents": [
        2,
        1.05,
        0.113
      ],
      "material": "tile",
      "note": "A south stair step 14"
    },
    {
      "kind": "box",
      "center": [
        -24,
        1.125,
        -4.752
      ],
      "halfExtents": [
        2,
        1.125,
        0.113
      ],
      "material": "tile",
      "note": "A south stair step 15"
    },
    {
      "kind": "box",
      "center": [
        -24,
        1.2,
        -4.977
      ],
      "halfExtents": [
        2,
        1.2,
        0.113
      ],
      "material": "tile",
      "note": "A south stair step 16"
    },
    {
      "kind": "box",
      "center": [
        -24,
        1.275,
        -5.202
      ],
      "halfExtents": [
        2,
        1.275,
        0.113
      ],
      "material": "tile",
      "note": "A south stair step 17"
    },
    {
      "kind": "box",
      "center": [
        -24,
        1.35,
        -5.427
      ],
      "halfExtents": [
        2,
        1.35,
        0.113
      ],
      "material": "tile",
      "note": "A south stair step 18"
    },
    {
      "kind": "box",
      "center": [
        -24,
        1.425,
        -5.653
      ],
      "halfExtents": [
        2,
        1.425,
        0.113
      ],
      "material": "tile",
      "note": "A south stair step 19"
    },
    {
      "kind": "box",
      "center": [
        -24,
        1.5,
        -5.877
      ],
      "halfExtents": [
        2,
        1.5,
        0.113
      ],
      "material": "tile",
      "note": "A south stair step 20"
    },
    {
      "kind": "box",
      "center": [
        -30,
        0.075,
        -28.397
      ],
      "halfExtents": [
        2,
        0.075,
        0.113
      ],
      "material": "tile",
      "note": "A north stair step 1"
    },
    {
      "kind": "box",
      "center": [
        -30,
        0.15,
        -28.173
      ],
      "halfExtents": [
        2,
        0.15,
        0.113
      ],
      "material": "tile",
      "note": "A north stair step 2"
    },
    {
      "kind": "box",
      "center": [
        -30,
        0.225,
        -27.947
      ],
      "halfExtents": [
        2,
        0.225,
        0.113
      ],
      "material": "tile",
      "note": "A north stair step 3"
    },
    {
      "kind": "box",
      "center": [
        -30,
        0.3,
        -27.722
      ],
      "halfExtents": [
        2,
        0.3,
        0.113
      ],
      "material": "tile",
      "note": "A north stair step 4"
    },
    {
      "kind": "box",
      "center": [
        -30,
        0.375,
        -27.498
      ],
      "halfExtents": [
        2,
        0.375,
        0.113
      ],
      "material": "tile",
      "note": "A north stair step 5"
    },
    {
      "kind": "box",
      "center": [
        -30,
        0.45,
        -27.272
      ],
      "halfExtents": [
        2,
        0.45,
        0.113
      ],
      "material": "tile",
      "note": "A north stair step 6"
    },
    {
      "kind": "box",
      "center": [
        -30,
        0.525,
        -27.048
      ],
      "halfExtents": [
        2,
        0.525,
        0.113
      ],
      "material": "tile",
      "note": "A north stair step 7"
    },
    {
      "kind": "box",
      "center": [
        -30,
        0.6,
        -26.822
      ],
      "halfExtents": [
        2,
        0.6,
        0.113
      ],
      "material": "tile",
      "note": "A north stair step 8"
    },
    {
      "kind": "box",
      "center": [
        -30,
        0.675,
        -26.597
      ],
      "halfExtents": [
        2,
        0.675,
        0.113
      ],
      "material": "tile",
      "note": "A north stair step 9"
    },
    {
      "kind": "box",
      "center": [
        -30,
        0.75,
        -26.373
      ],
      "halfExtents": [
        2,
        0.75,
        0.113
      ],
      "material": "tile",
      "note": "A north stair step 10"
    },
    {
      "kind": "box",
      "center": [
        -30,
        0.825,
        -26.147
      ],
      "halfExtents": [
        2,
        0.825,
        0.113
      ],
      "material": "tile",
      "note": "A north stair step 11"
    },
    {
      "kind": "box",
      "center": [
        -30,
        0.9,
        -25.923
      ],
      "halfExtents": [
        2,
        0.9,
        0.113
      ],
      "material": "tile",
      "note": "A north stair step 12"
    },
    {
      "kind": "box",
      "center": [
        -30,
        0.975,
        -25.697
      ],
      "halfExtents": [
        2,
        0.975,
        0.113
      ],
      "material": "tile",
      "note": "A north stair step 13"
    },
    {
      "kind": "box",
      "center": [
        -30,
        1.05,
        -25.472
      ],
      "halfExtents": [
        2,
        1.05,
        0.113
      ],
      "material": "tile",
      "note": "A north stair step 14"
    },
    {
      "kind": "box",
      "center": [
        -30,
        1.125,
        -25.248
      ],
      "halfExtents": [
        2,
        1.125,
        0.113
      ],
      "material": "tile",
      "note": "A north stair step 15"
    },
    {
      "kind": "box",
      "center": [
        -30,
        1.2,
        -25.022
      ],
      "halfExtents": [
        2,
        1.2,
        0.113
      ],
      "material": "tile",
      "note": "A north stair step 16"
    },
    {
      "kind": "box",
      "center": [
        -30,
        1.275,
        -24.798
      ],
      "halfExtents": [
        2,
        1.275,
        0.113
      ],
      "material": "tile",
      "note": "A north stair step 17"
    },
    {
      "kind": "box",
      "center": [
        -30,
        1.35,
        -24.572
      ],
      "halfExtents": [
        2,
        1.35,
        0.113
      ],
      "material": "tile",
      "note": "A north stair step 18"
    },
    {
      "kind": "box",
      "center": [
        -30,
        1.425,
        -24.347
      ],
      "halfExtents": [
        2,
        1.425,
        0.113
      ],
      "material": "tile",
      "note": "A north stair step 19"
    },
    {
      "kind": "box",
      "center": [
        -30,
        1.5,
        -24.123
      ],
      "halfExtents": [
        2,
        1.5,
        0.113
      ],
      "material": "tile",
      "note": "A north stair step 20"
    },
    {
      "kind": "box",
      "center": [
        -33,
        3.3,
        -16
      ],
      "halfExtents": [
        3,
        0.3,
        4
      ],
      "material": "tile",
      "note": "A platform tier 1"
    },
    {
      "kind": "box",
      "center": [
        -33,
        3.9,
        -16
      ],
      "halfExtents": [
        1,
        0.3,
        2
      ],
      "material": "tile",
      "note": "A platform tier 2"
    },
    {
      "kind": "box",
      "center": [
        -16,
        4.1,
        -22
      ],
      "halfExtents": [
        0.4,
        1.1,
        0.4
      ],
      "material": "brick",
      "hidden": true,
      "note": "column collision"
    },
    {
      "kind": "box",
      "center": [
        -16,
        3.5,
        -18
      ],
      "halfExtents": [
        0.45,
        0.5,
        0.45
      ],
      "material": "brick",
      "note": "broken column"
    },
    {
      "kind": "box",
      "center": [
        -16,
        4.1,
        -14
      ],
      "halfExtents": [
        0.4,
        1.1,
        0.4
      ],
      "material": "brick",
      "hidden": true,
      "note": "column collision"
    },
    {
      "kind": "box",
      "center": [
        -16,
        3.5,
        -10
      ],
      "halfExtents": [
        0.45,
        0.5,
        0.45
      ],
      "material": "brick",
      "note": "broken column"
    },
    {
      "kind": "box",
      "center": [
        -24,
        3.6,
        -20
      ],
      "halfExtents": [
        1.2,
        0.6,
        0.8
      ],
      "material": "brick",
      "note": "stone block"
    },
    {
      "kind": "box",
      "center": [
        -20,
        3.6,
        -9
      ],
      "halfExtents": [
        1.2,
        0.6,
        0.8
      ],
      "material": "brick",
      "note": "stone block"
    },
    {
      "kind": "box",
      "center": [
        -24,
        -0.14,
        12.75
      ],
      "halfExtents": [
        4,
        0.15,
        14.25
      ],
      "material": "gravel",
      "note": "A approach path"
    },
    {
      "kind": "box",
      "center": [
        -33,
        1.2,
        4.3
      ],
      "halfExtents": [
        5,
        1.2,
        0.3
      ],
      "material": "plaster",
      "note": "A ruined wall"
    },
    {
      "kind": "box",
      "center": [
        -16,
        1.2,
        14.3
      ],
      "halfExtents": [
        4,
        1.2,
        0.3
      ],
      "material": "plaster",
      "note": "A ruined wall"
    },
    {
      "kind": "box",
      "center": [
        -35,
        1.3,
        10.2
      ],
      "halfExtents": [
        3,
        1.3,
        0.2
      ],
      "material": "plaster",
      "note": "A shrine north wall"
    },
    {
      "kind": "box",
      "center": [
        -37,
        1.3,
        15.8
      ],
      "halfExtents": [
        1,
        1.3,
        0.2
      ],
      "material": "plaster",
      "note": "A shrine south wall"
    },
    {
      "kind": "box",
      "center": [
        -33,
        1.3,
        15.8
      ],
      "halfExtents": [
        1,
        1.3,
        0.2
      ],
      "material": "plaster",
      "note": "A shrine south wall"
    },
    {
      "kind": "box",
      "center": [
        -32.2,
        1.3,
        11.2
      ],
      "halfExtents": [
        0.2,
        1.3,
        0.8
      ],
      "material": "plaster",
      "note": "A shrine east wall"
    },
    {
      "kind": "box",
      "center": [
        -32.2,
        1.3,
        14.8
      ],
      "halfExtents": [
        0.2,
        1.3,
        0.8
      ],
      "material": "plaster",
      "note": "A shrine east wall"
    },
    {
      "kind": "box",
      "center": [
        -37.8,
        1.3,
        13
      ],
      "halfExtents": [
        0.2,
        1.3,
        2.6
      ],
      "material": "plaster",
      "note": "A shrine west wall"
    },
    {
      "kind": "box",
      "center": [
        -35,
        2.3,
        13
      ],
      "halfExtents": [
        0.12,
        0.05,
        0.12
      ],
      "material": "metal",
      "emissive": "#ffd8a0",
      "emissiveIntensity": 3,
      "note": "A shrine lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        -34,
        0.7,
        21
      ],
      "halfExtents": [
        1.5,
        0.7,
        1
      ],
      "material": "brick",
      "note": "stone block"
    },
    {
      "kind": "box",
      "center": [
        -14,
        0.6,
        2
      ],
      "halfExtents": [
        1.2,
        0.6,
        1.2
      ],
      "material": "brick",
      "note": "stone block"
    },
    {
      "kind": "box",
      "center": [
        -32,
        0.75,
        -3
      ],
      "halfExtents": [
        1.5,
        0.75,
        1
      ],
      "material": "brick",
      "note": "stone block"
    },
    {
      "kind": "box",
      "center": [
        -10,
        0.7,
        20
      ],
      "halfExtents": [
        1.2,
        0.7,
        0.8
      ],
      "material": "brick",
      "note": "stone block"
    },
    {
      "kind": "box",
      "center": [
        -39,
        0.45,
        25
      ],
      "halfExtents": [
        0.7,
        0.45,
        0.7
      ],
      "material": "sand",
      "hidden": true,
      "note": "rock collision"
    },
    {
      "kind": "box",
      "center": [
        -19,
        0.45,
        22
      ],
      "halfExtents": [
        0.7,
        0.45,
        0.7
      ],
      "material": "sand",
      "hidden": true,
      "note": "rock collision"
    },
    {
      "kind": "box",
      "center": [
        -34,
        0.45,
        -4.5
      ],
      "halfExtents": [
        0.7,
        0.45,
        0.7
      ],
      "material": "sand",
      "hidden": true,
      "note": "rock collision"
    },
    {
      "kind": "box",
      "center": [
        -10,
        0.45,
        -3
      ],
      "halfExtents": [
        0.7,
        0.45,
        0.7
      ],
      "material": "sand",
      "hidden": true,
      "note": "rock collision"
    },
    {
      "kind": "box",
      "center": [
        -36,
        0.7,
        -33
      ],
      "halfExtents": [
        1.5,
        0.7,
        1
      ],
      "material": "brick",
      "note": "stone block"
    },
    {
      "kind": "box",
      "center": [
        -24,
        0.45,
        -35
      ],
      "halfExtents": [
        0.7,
        0.45,
        0.7
      ],
      "material": "sand",
      "hidden": true,
      "note": "rock collision"
    },
    {
      "kind": "box",
      "center": [
        25.25,
        1.5,
        7.8
      ],
      "halfExtents": [
        1.25,
        1.5,
        0.2
      ],
      "material": "brick",
      "note": "B tunnel south wall"
    },
    {
      "kind": "box",
      "center": [
        28,
        2.7,
        7.8
      ],
      "halfExtents": [
        1.5,
        0.3,
        0.2
      ],
      "material": "brick",
      "note": "B tunnel south lintel"
    },
    {
      "kind": "box",
      "center": [
        30.75,
        1.5,
        7.8
      ],
      "halfExtents": [
        1.25,
        1.5,
        0.2
      ],
      "material": "brick",
      "note": "B tunnel south wall"
    },
    {
      "kind": "box",
      "center": [
        31.8,
        1.5,
        -1
      ],
      "halfExtents": [
        0.2,
        1.5,
        8.6
      ],
      "material": "brick",
      "note": "B tunnel east wall"
    },
    {
      "kind": "box",
      "center": [
        24.2,
        1.5,
        -1
      ],
      "halfExtents": [
        0.2,
        1.5,
        8.6
      ],
      "material": "brick",
      "note": "B tunnel west wall"
    },
    {
      "kind": "box",
      "center": [
        28,
        3.2,
        -1
      ],
      "halfExtents": [
        4,
        0.2,
        9
      ],
      "material": "brick",
      "note": "B tunnel roof"
    },
    {
      "kind": "box",
      "center": [
        28,
        2.75,
        -6
      ],
      "halfExtents": [
        0.12,
        0.05,
        0.12
      ],
      "material": "metal",
      "emissive": "#ffd8a0",
      "emissiveIntensity": 3,
      "note": "B tunnel lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        28,
        2.75,
        0
      ],
      "halfExtents": [
        0.12,
        0.05,
        0.12
      ],
      "material": "metal",
      "emissive": "#ffd8a0",
      "emissiveIntensity": 3,
      "note": "B tunnel lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        28,
        2.75,
        6
      ],
      "halfExtents": [
        0.12,
        0.05,
        0.12
      ],
      "material": "metal",
      "emissive": "#ffd8a0",
      "emissiveIntensity": 3,
      "note": "B tunnel lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        25.5,
        1.1,
        9.5
      ],
      "halfExtents": [
        0.4,
        1.1,
        0.4
      ],
      "material": "brick",
      "hidden": true,
      "note": "column collision"
    },
    {
      "kind": "box",
      "center": [
        30.5,
        1.1,
        9.5
      ],
      "halfExtents": [
        0.4,
        1.1,
        0.4
      ],
      "material": "brick",
      "hidden": true,
      "note": "column collision"
    },
    {
      "kind": "box",
      "center": [
        28,
        -0.14,
        17.5
      ],
      "halfExtents": [
        3,
        0.15,
        9.5
      ],
      "material": "gravel",
      "note": "B approach path"
    },
    {
      "kind": "box",
      "center": [
        22.148,
        -1.425,
        -19
      ],
      "halfExtents": [
        0.113,
        0.075,
        1.5
      ],
      "material": "tile",
      "note": "B pit west stair step 1"
    },
    {
      "kind": "box",
      "center": [
        21.923,
        -1.35,
        -19
      ],
      "halfExtents": [
        0.113,
        0.15,
        1.5
      ],
      "material": "tile",
      "note": "B pit west stair step 2"
    },
    {
      "kind": "box",
      "center": [
        21.698,
        -1.275,
        -19
      ],
      "halfExtents": [
        0.113,
        0.225,
        1.5
      ],
      "material": "tile",
      "note": "B pit west stair step 3"
    },
    {
      "kind": "box",
      "center": [
        21.473,
        -1.2,
        -19
      ],
      "halfExtents": [
        0.113,
        0.3,
        1.5
      ],
      "material": "tile",
      "note": "B pit west stair step 4"
    },
    {
      "kind": "box",
      "center": [
        21.248,
        -1.125,
        -19
      ],
      "halfExtents": [
        0.113,
        0.375,
        1.5
      ],
      "material": "tile",
      "note": "B pit west stair step 5"
    },
    {
      "kind": "box",
      "center": [
        21.023,
        -1.05,
        -19
      ],
      "halfExtents": [
        0.113,
        0.45,
        1.5
      ],
      "material": "tile",
      "note": "B pit west stair step 6"
    },
    {
      "kind": "box",
      "center": [
        20.798,
        -0.975,
        -19
      ],
      "halfExtents": [
        0.113,
        0.525,
        1.5
      ],
      "material": "tile",
      "note": "B pit west stair step 7"
    },
    {
      "kind": "box",
      "center": [
        20.573,
        -0.9,
        -19
      ],
      "halfExtents": [
        0.113,
        0.6,
        1.5
      ],
      "material": "tile",
      "note": "B pit west stair step 8"
    },
    {
      "kind": "box",
      "center": [
        20.348,
        -0.825,
        -19
      ],
      "halfExtents": [
        0.113,
        0.675,
        1.5
      ],
      "material": "tile",
      "note": "B pit west stair step 9"
    },
    {
      "kind": "box",
      "center": [
        20.123,
        -0.75,
        -19
      ],
      "halfExtents": [
        0.113,
        0.75,
        1.5
      ],
      "material": "tile",
      "note": "B pit west stair step 10"
    },
    {
      "kind": "box",
      "center": [
        29,
        -1.425,
        -25.852
      ],
      "halfExtents": [
        1.5,
        0.075,
        0.113
      ],
      "material": "tile",
      "note": "B pit north stair step 1"
    },
    {
      "kind": "box",
      "center": [
        29,
        -1.35,
        -26.077
      ],
      "halfExtents": [
        1.5,
        0.15,
        0.113
      ],
      "material": "tile",
      "note": "B pit north stair step 2"
    },
    {
      "kind": "box",
      "center": [
        29,
        -1.275,
        -26.302
      ],
      "halfExtents": [
        1.5,
        0.225,
        0.113
      ],
      "material": "tile",
      "note": "B pit north stair step 3"
    },
    {
      "kind": "box",
      "center": [
        29,
        -1.2,
        -26.527
      ],
      "halfExtents": [
        1.5,
        0.3,
        0.113
      ],
      "material": "tile",
      "note": "B pit north stair step 4"
    },
    {
      "kind": "box",
      "center": [
        29,
        -1.125,
        -26.752
      ],
      "halfExtents": [
        1.5,
        0.375,
        0.113
      ],
      "material": "tile",
      "note": "B pit north stair step 5"
    },
    {
      "kind": "box",
      "center": [
        29,
        -1.05,
        -26.977
      ],
      "halfExtents": [
        1.5,
        0.45,
        0.113
      ],
      "material": "tile",
      "note": "B pit north stair step 6"
    },
    {
      "kind": "box",
      "center": [
        29,
        -0.975,
        -27.202
      ],
      "halfExtents": [
        1.5,
        0.525,
        0.113
      ],
      "material": "tile",
      "note": "B pit north stair step 7"
    },
    {
      "kind": "box",
      "center": [
        29,
        -0.9,
        -27.427
      ],
      "halfExtents": [
        1.5,
        0.6,
        0.113
      ],
      "material": "tile",
      "note": "B pit north stair step 8"
    },
    {
      "kind": "box",
      "center": [
        29,
        -0.825,
        -27.652
      ],
      "halfExtents": [
        1.5,
        0.675,
        0.113
      ],
      "material": "tile",
      "note": "B pit north stair step 9"
    },
    {
      "kind": "box",
      "center": [
        29,
        -0.75,
        -27.877
      ],
      "halfExtents": [
        1.5,
        0.75,
        0.113
      ],
      "material": "tile",
      "note": "B pit north stair step 10"
    },
    {
      "kind": "box",
      "center": [
        29,
        -1,
        -23.5
      ],
      "halfExtents": [
        1.5,
        0.5,
        1.5
      ],
      "material": "tile",
      "note": "B altar"
    },
    {
      "kind": "box",
      "center": [
        24,
        -0.6,
        -14
      ],
      "halfExtents": [
        1,
        0.9,
        1
      ],
      "material": "sand",
      "hidden": true,
      "note": "rock collision"
    },
    {
      "kind": "box",
      "center": [
        34,
        -0.6,
        -24
      ],
      "halfExtents": [
        1,
        0.9,
        1
      ],
      "material": "sand",
      "hidden": true,
      "note": "rock collision"
    },
    {
      "kind": "box",
      "center": [
        35,
        -0.6,
        -13
      ],
      "halfExtents": [
        1,
        0.9,
        1
      ],
      "material": "sand",
      "hidden": true,
      "note": "rock collision"
    },
    {
      "kind": "box",
      "center": [
        10.25,
        2,
        -4.25
      ],
      "halfExtents": [
        2.75,
        2,
        0.25
      ],
      "material": "brick",
      "note": "pocket wall"
    },
    {
      "kind": "box",
      "center": [
        20,
        2,
        -4.25
      ],
      "halfExtents": [
        4,
        2,
        0.25
      ],
      "material": "brick",
      "note": "pocket wall"
    },
    {
      "kind": "box",
      "center": [
        14.5,
        3.3,
        -4.25
      ],
      "halfExtents": [
        1.5,
        0.7,
        0.25
      ],
      "material": "brick",
      "note": "pocket wall lintel"
    },
    {
      "kind": "box",
      "center": [
        14.5,
        2.45,
        -4.25
      ],
      "halfExtents": [
        0.25,
        0.05,
        0.15
      ],
      "material": "metal",
      "emissive": "#ffcf90",
      "emissiveIntensity": 3,
      "note": "pocket doorway lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        12,
        0.7,
        -14
      ],
      "halfExtents": [
        1.2,
        0.7,
        0.8
      ],
      "material": "brick",
      "note": "stone block"
    },
    {
      "kind": "box",
      "center": [
        12,
        0.6,
        -24
      ],
      "halfExtents": [
        1.2,
        0.6,
        0.8
      ],
      "material": "brick",
      "note": "stone block"
    },
    {
      "kind": "box",
      "center": [
        15,
        1.2,
        6.3
      ],
      "halfExtents": [
        5,
        1.2,
        0.3
      ],
      "material": "plaster",
      "note": "B ruined wall"
    },
    {
      "kind": "box",
      "center": [
        37.75,
        1.2,
        12.3
      ],
      "halfExtents": [
        3.75,
        1.2,
        0.3
      ],
      "material": "plaster",
      "note": "B ruined wall"
    },
    {
      "kind": "box",
      "center": [
        35,
        1.3,
        18.2
      ],
      "halfExtents": [
        1,
        1.3,
        0.2
      ],
      "material": "plaster",
      "note": "B shrine north wall"
    },
    {
      "kind": "box",
      "center": [
        39,
        1.3,
        18.2
      ],
      "halfExtents": [
        1,
        1.3,
        0.2
      ],
      "material": "plaster",
      "note": "B shrine north wall"
    },
    {
      "kind": "box",
      "center": [
        37,
        1.3,
        23.8
      ],
      "halfExtents": [
        3,
        1.3,
        0.2
      ],
      "material": "plaster",
      "note": "B shrine south wall"
    },
    {
      "kind": "box",
      "center": [
        39.8,
        1.3,
        21
      ],
      "halfExtents": [
        0.2,
        1.3,
        2.6
      ],
      "material": "plaster",
      "note": "B shrine east wall"
    },
    {
      "kind": "box",
      "center": [
        34.2,
        1.3,
        19.2
      ],
      "halfExtents": [
        0.2,
        1.3,
        0.8
      ],
      "material": "plaster",
      "note": "B shrine west wall"
    },
    {
      "kind": "box",
      "center": [
        34.2,
        1.3,
        22.8
      ],
      "halfExtents": [
        0.2,
        1.3,
        0.8
      ],
      "material": "plaster",
      "note": "B shrine west wall"
    },
    {
      "kind": "box",
      "center": [
        37,
        2.3,
        21
      ],
      "halfExtents": [
        0.12,
        0.05,
        0.12
      ],
      "material": "metal",
      "emissive": "#ffd8a0",
      "emissiveIntensity": 3,
      "note": "B shrine lamp fixture"
    },
    {
      "kind": "box",
      "center": [
        20,
        0.7,
        0
      ],
      "halfExtents": [
        1.2,
        0.7,
        0.8
      ],
      "material": "brick",
      "note": "stone block"
    },
    {
      "kind": "box",
      "center": [
        36,
        0.6,
        2
      ],
      "halfExtents": [
        1.2,
        0.6,
        1.2
      ],
      "material": "brick",
      "note": "stone block"
    },
    {
      "kind": "box",
      "center": [
        16,
        0.7,
        16
      ],
      "halfExtents": [
        1.5,
        0.7,
        1
      ],
      "material": "brick",
      "note": "stone block"
    },
    {
      "kind": "box",
      "center": [
        36,
        0.7,
        26
      ],
      "halfExtents": [
        1.2,
        0.7,
        0.8
      ],
      "material": "brick",
      "note": "stone block"
    },
    {
      "kind": "box",
      "center": [
        39,
        0.45,
        5
      ],
      "halfExtents": [
        0.7,
        0.45,
        0.7
      ],
      "material": "sand",
      "hidden": true,
      "note": "rock collision"
    },
    {
      "kind": "box",
      "center": [
        12,
        0.45,
        22
      ],
      "halfExtents": [
        0.7,
        0.45,
        0.7
      ],
      "material": "sand",
      "hidden": true,
      "note": "rock collision"
    },
    {
      "kind": "box",
      "center": [
        22,
        0.45,
        14
      ],
      "halfExtents": [
        0.7,
        0.45,
        0.7
      ],
      "material": "sand",
      "hidden": true,
      "note": "rock collision"
    },
    {
      "kind": "box",
      "center": [
        36,
        0.7,
        -33
      ],
      "halfExtents": [
        1.5,
        0.7,
        1
      ],
      "material": "brick",
      "note": "stone block"
    },
    {
      "kind": "box",
      "center": [
        24,
        0.45,
        -35
      ],
      "halfExtents": [
        0.7,
        0.45,
        0.7
      ],
      "material": "sand",
      "hidden": true,
      "note": "rock collision"
    },
    {
      "kind": "box",
      "center": [
        -7.25,
        2.55,
        -18.5
      ],
      "halfExtents": [
        0.04,
        0.05,
        0.04
      ],
      "material": "metal",
      "note": "mid doorway lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        -7.25,
        2.55,
        11.5
      ],
      "halfExtents": [
        0.04,
        0.05,
        0.04
      ],
      "material": "metal",
      "note": "mid doorway lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        7.25,
        2.55,
        -18.5
      ],
      "halfExtents": [
        0.04,
        0.05,
        0.04
      ],
      "material": "metal",
      "note": "mid doorway lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        7.25,
        2.55,
        11.5
      ],
      "halfExtents": [
        0.04,
        0.05,
        0.04
      ],
      "material": "metal",
      "note": "mid doorway lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        -35,
        1.125,
        13
      ],
      "halfExtents": [
        0.04,
        1.125,
        0.04
      ],
      "material": "metal",
      "note": "A shrine lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        28,
        2.9,
        -6
      ],
      "halfExtents": [
        0.04,
        0.1,
        0.04
      ],
      "material": "metal",
      "note": "B tunnel lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        28,
        2.9,
        0
      ],
      "halfExtents": [
        0.04,
        0.1,
        0.04
      ],
      "material": "metal",
      "note": "B tunnel lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        28,
        2.9,
        6
      ],
      "halfExtents": [
        0.04,
        0.1,
        0.04
      ],
      "material": "metal",
      "note": "B tunnel lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        14.5,
        2.55,
        -4.25
      ],
      "halfExtents": [
        0.04,
        0.05,
        0.04
      ],
      "material": "metal",
      "note": "pocket doorway lamp fixture mount"
    },
    {
      "kind": "box",
      "center": [
        37,
        1.125,
        21
      ],
      "halfExtents": [
        0.04,
        1.125,
        0.04
      ],
      "material": "metal",
      "note": "B shrine lamp fixture mount"
    }
  ],
  "spawns": [
    {
      "position": [
        -14,
        0.05,
        35.5
      ],
      "yaw": 5.908,
      "team": 0
    },
    {
      "position": [
        -14,
        2.55,
        -35.5
      ],
      "yaw": 3.517,
      "team": 1
    },
    {
      "position": [
        -10,
        0.05,
        35.5
      ],
      "yaw": 6.009,
      "team": 0
    },
    {
      "position": [
        -10,
        2.55,
        -35.5
      ],
      "yaw": 3.416,
      "team": 1
    },
    {
      "position": [
        -6,
        0.05,
        35.5
      ],
      "yaw": 6.116,
      "team": 0
    },
    {
      "position": [
        -6,
        2.55,
        -35.5
      ],
      "yaw": 3.309,
      "team": 1
    },
    {
      "position": [
        -2,
        0.05,
        35.5
      ],
      "yaw": 6.227,
      "team": 0
    },
    {
      "position": [
        -2,
        2.55,
        -35.5
      ],
      "yaw": 3.198,
      "team": 1
    },
    {
      "position": [
        2,
        0.05,
        35.5
      ],
      "yaw": 0.056,
      "team": 0
    },
    {
      "position": [
        2,
        2.55,
        -35.5
      ],
      "yaw": 3.085,
      "team": 1
    },
    {
      "position": [
        6,
        0.05,
        35.5
      ],
      "yaw": 0.167,
      "team": 0
    },
    {
      "position": [
        6,
        2.55,
        -35.5
      ],
      "yaw": 2.974,
      "team": 1
    },
    {
      "position": [
        10,
        0.05,
        35.5
      ],
      "yaw": 0.275,
      "team": 0
    },
    {
      "position": [
        10,
        2.55,
        -35.5
      ],
      "yaw": 2.867,
      "team": 1
    },
    {
      "position": [
        14,
        0.05,
        35.5
      ],
      "yaw": 0.376,
      "team": 0
    },
    {
      "position": [
        14,
        2.55,
        -35.5
      ],
      "yaw": 2.766,
      "team": 1
    }
  ],
  "props": [
    {
      "model": "/game/models/props/rock-b.glb",
      "position": [
        -24,
        0,
        34
      ],
      "yaw": 0.6,
      "note": "rock b"
    },
    {
      "model": "/game/models/props/rock-a.glb",
      "position": [
        24,
        0,
        34
      ],
      "yaw": 2.1,
      "note": "rock a"
    },
    {
      "model": "/game/models/kit/column.glb",
      "position": [
        -16,
        3,
        -22
      ],
      "scale": 2,
      "note": "temple column"
    },
    {
      "model": "/game/models/kit/column.glb",
      "position": [
        -16,
        3,
        -14
      ],
      "scale": 2,
      "note": "temple column"
    },
    {
      "model": "/game/models/props/rock-a.glb",
      "position": [
        -39,
        0,
        25
      ],
      "yaw": 1.2,
      "note": "rock a"
    },
    {
      "model": "/game/models/props/rock-c.glb",
      "position": [
        -19,
        0,
        22
      ],
      "yaw": 0.3,
      "note": "rock c"
    },
    {
      "model": "/game/models/props/rock-b.glb",
      "position": [
        -34,
        0,
        -4.5
      ],
      "yaw": 2.6,
      "note": "rock b"
    },
    {
      "model": "/game/models/props/rock-c.glb",
      "position": [
        -10,
        0,
        -3
      ],
      "yaw": 1.9,
      "note": "rock c"
    },
    {
      "model": "/game/models/props/rock-a.glb",
      "position": [
        -24,
        0,
        -35
      ],
      "yaw": 0.9,
      "note": "rock a"
    },
    {
      "model": "/game/models/kit/column.glb",
      "position": [
        25.5,
        0,
        9.5
      ],
      "scale": 2,
      "note": "temple column"
    },
    {
      "model": "/game/models/kit/column.glb",
      "position": [
        30.5,
        0,
        9.5
      ],
      "scale": 2,
      "note": "temple column"
    },
    {
      "model": "/game/models/props/rock-b.glb",
      "position": [
        24,
        -1.5,
        -14
      ],
      "yaw": 0.4,
      "scale": 2,
      "note": "rock b"
    },
    {
      "model": "/game/models/props/rock-c.glb",
      "position": [
        34,
        -1.5,
        -24
      ],
      "yaw": 1.7,
      "scale": 2,
      "note": "rock c"
    },
    {
      "model": "/game/models/props/rock-a.glb",
      "position": [
        35,
        -1.5,
        -13
      ],
      "yaw": 2.9,
      "scale": 2,
      "note": "rock a"
    },
    {
      "model": "/game/models/props/rock-a.glb",
      "position": [
        39,
        0,
        5
      ],
      "yaw": 0.8,
      "note": "rock a"
    },
    {
      "model": "/game/models/props/rock-b.glb",
      "position": [
        12,
        0,
        22
      ],
      "yaw": 2.2,
      "note": "rock b"
    },
    {
      "model": "/game/models/props/rock-c.glb",
      "position": [
        22,
        0,
        14
      ],
      "yaw": 1.1,
      "note": "rock c"
    },
    {
      "model": "/game/models/props/rock-c.glb",
      "position": [
        24,
        0,
        -35
      ],
      "yaw": 2.4,
      "note": "rock c"
    }
  ],
  "lights": [
    {
      "kind": "spot",
      "position": [
        0,
        6.5,
        36
      ],
      "color": "#fff1d6",
      "intensity": 320,
      "distance": 30,
      "target": [
        0,
        0,
        31
      ],
      "angle": 0.8,
      "penumbra": 0.4,
      "castShadow": true,
      "note": "T0 path flood"
    },
    {
      "kind": "point",
      "position": [
        -11.25,
        2,
        -31.5
      ],
      "color": "#ffd8a0",
      "intensity": 30,
      "distance": 8,
      "note": "undercroft lamp"
    },
    {
      "kind": "point",
      "position": [
        -3.75,
        2,
        -31.5
      ],
      "color": "#ffd8a0",
      "intensity": 30,
      "distance": 8,
      "note": "undercroft lamp"
    },
    {
      "kind": "point",
      "position": [
        3.75,
        2,
        -31.5
      ],
      "color": "#ffd8a0",
      "intensity": 30,
      "distance": 8,
      "note": "undercroft lamp"
    },
    {
      "kind": "point",
      "position": [
        11.25,
        2,
        -31.5
      ],
      "color": "#ffd8a0",
      "intensity": 30,
      "distance": 8,
      "note": "undercroft lamp"
    },
    {
      "kind": "spot",
      "position": [
        0,
        6.8,
        -36
      ],
      "color": "#fff1d6",
      "intensity": 320,
      "distance": 30,
      "target": [
        0,
        2.5,
        -31
      ],
      "angle": 0.8,
      "penumbra": 0.4,
      "castShadow": true,
      "note": "terrace flood"
    },
    {
      "kind": "point",
      "position": [
        -7.25,
        2.45,
        -18.5
      ],
      "color": "#ffcf90",
      "intensity": 30,
      "distance": 8,
      "note": "mid doorway lamp"
    },
    {
      "kind": "point",
      "position": [
        -7.25,
        2.45,
        11.5
      ],
      "color": "#ffcf90",
      "intensity": 30,
      "distance": 8,
      "note": "mid doorway lamp"
    },
    {
      "kind": "point",
      "position": [
        7.25,
        2.45,
        -18.5
      ],
      "color": "#ffcf90",
      "intensity": 30,
      "distance": 8,
      "note": "mid doorway lamp"
    },
    {
      "kind": "point",
      "position": [
        7.25,
        2.45,
        11.5
      ],
      "color": "#ffcf90",
      "intensity": 30,
      "distance": 8,
      "note": "mid doorway lamp"
    },
    {
      "kind": "point",
      "position": [
        -2.8,
        3,
        0
      ],
      "color": "#ffcf90",
      "intensity": 30,
      "distance": 8,
      "note": "gate lamp"
    },
    {
      "kind": "point",
      "position": [
        2.8,
        3,
        0
      ],
      "color": "#ffcf90",
      "intensity": 30,
      "distance": 8,
      "note": "gate lamp"
    },
    {
      "kind": "spot",
      "position": [
        -41,
        6.5,
        -15
      ],
      "color": "#ffe9c4",
      "intensity": 300,
      "distance": 30,
      "target": [
        -27,
        3,
        -15
      ],
      "angle": 0.7,
      "penumbra": 0.4,
      "castShadow": true,
      "note": "site A flood"
    },
    {
      "kind": "point",
      "position": [
        -35,
        2.3,
        13
      ],
      "color": "#ffd8a0",
      "intensity": 30,
      "distance": 8,
      "note": "A shrine lamp"
    },
    {
      "kind": "point",
      "position": [
        28,
        2.75,
        -6
      ],
      "color": "#ffd8a0",
      "intensity": 35,
      "distance": 9,
      "note": "B tunnel lamp"
    },
    {
      "kind": "point",
      "position": [
        28,
        2.75,
        0
      ],
      "color": "#ffd8a0",
      "intensity": 35,
      "distance": 9,
      "note": "B tunnel lamp"
    },
    {
      "kind": "point",
      "position": [
        28,
        2.75,
        6
      ],
      "color": "#ffd8a0",
      "intensity": 35,
      "distance": 9,
      "note": "B tunnel lamp"
    },
    {
      "kind": "spot",
      "position": [
        41,
        6.5,
        -19
      ],
      "color": "#ffe9c4",
      "intensity": 300,
      "distance": 30,
      "target": [
        29,
        -1.5,
        -19
      ],
      "angle": 0.7,
      "penumbra": 0.4,
      "note": "site B flood"
    },
    {
      "kind": "point",
      "position": [
        14.5,
        2.45,
        -4.25
      ],
      "color": "#ffcf90",
      "intensity": 30,
      "distance": 8,
      "note": "pocket doorway lamp"
    },
    {
      "kind": "point",
      "position": [
        37,
        2.3,
        21
      ],
      "color": "#ffd8a0",
      "intensity": 30,
      "distance": 8,
      "note": "B shrine lamp"
    }
  ],
  "sites": [
    {
      "id": "A",
      "center": [
        -27,
        3,
        -15
      ],
      "halfExtents": [
        4,
        2,
        4
      ]
    },
    {
      "id": "B",
      "center": [
        29,
        -1.5,
        -17
      ],
      "halfExtents": [
        4,
        2,
        4
      ]
    }
  ]
}
